import { useContext } from "react";
import { TranslationContext, type TranslationContextType } from "./TranslationContext";

export const useTranslation = (): TranslationContextType =>
  useContext(TranslationContext);
